import React from "react";
import BaseView from "../BaseView";
import NavbarViewModel from "../../view-model/navbar/NavbarViewModel";
import exitIcon from "../../../assets/exit.svg";
import logoIcon from "../../../assets/logo.png";
import columnsIcon from "../../../assets/columns.svg";
import usersIcon from "../../../assets/users.svg";
import userIcon from "../../../assets/card.svg";
import CountryItem from "../../../domain/models/country/CountryItem";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

interface State {
  isShowDashboardIcon: boolean;
  isShowUsersIcon: boolean;

  isShowCountriesList: boolean;
  countriesList: CountryItem[];
  selectedCountryItem: CountryItem;
}

interface Props {
  adminNavbarViewModel: NavbarViewModel;
}

export default class NavbarComponent extends React.Component<Props, State> implements BaseView {
  private navbarViewModel: NavbarViewModel;

  public constructor(props: Props) {
    super(props);
    this.navbarViewModel = props.adminNavbarViewModel;

    this.state = {
      isShowDashboardIcon: this.navbarViewModel.isShowDashboardIcon,
      isShowUsersIcon: this.navbarViewModel.isShowUsersIcon,

      isShowCountriesList: this.navbarViewModel.isShowCountriesList,
      countriesList: this.navbarViewModel.countriesList,
      selectedCountryItem: this.navbarViewModel.selectedCountryItem,
    };
  }

  public componentDidMount = (): void => {
    this.navbarViewModel.attachView(this);
  };

  public componentWillUnmount = (): void => {
    this.navbarViewModel.detachView(this);
  };

  public onViewModelChanged = (): void => {
    this.setState({
      isShowDashboardIcon: this.navbarViewModel.isShowDashboardIcon,
      isShowUsersIcon: this.navbarViewModel.isShowUsersIcon,

      isShowCountriesList: this.navbarViewModel.isShowCountriesList,
      countriesList: this.navbarViewModel.countriesList,
      selectedCountryItem: this.navbarViewModel.selectedCountryItem,
    });
  };

  public render = (): JSX.Element => {
    const {
      isShowDashboardIcon,
      isShowUsersIcon,

      isShowCountriesList,
      countriesList,
      selectedCountryItem,
    } = this.state;

    return (
      <div className="container-fluid" style={{ background: "#223340", zIndex: 1 }}>
        <div className="row align-items-center justify-content-between" style={{ height: "90px" }}>
          <div
            className="font-weight-bold text-white ml-5 px-4"
            style={{ cursor: "pointer", width: "450px", maxWidth: "450px" }}
            onClick={(): void => this.navbarViewModel.onDashboardClicked()}
          >
            <img src={logoIcon} height={65} />
          </div>

          <div
            className="d-flex flex-row justify-content-center align-items-center text-white mr-5"
            style={{ height: "50px" }}
          >
            support365@freshdesk.com
          </div>

          <div className="d-flex flex-row align-items-center" style={{ width: "450px", maxWidth: "450px" }}>
            {isShowCountriesList ? (
              <select
                value={selectedCountryItem.countryAbbreviation}
                onChange={(e): void => {
                  const countryAbbreviation = e.target.value;
                  const selectedCountry = countriesList.filter(
                    (country) => country.countryAbbreviation === countryAbbreviation
                  )[0];

                  this.navbarViewModel.onCountrySelected(selectedCountry);
                }}
                className="form-control form-control-sm mr-5"
                style={{ maxWidth: "250px" }}
              >
                {countriesList.map((country) => {
                  return (
                    <option
                      key={`country_${country.countryAbbreviation}`}
                      value={country.countryAbbreviation}
                    >{`(${country.countryAbbreviation}) ${country.amazonUrl}`}</option>
                  );
                })}
              </select>
            ) : (
              <div style={{ width: "250px" }} />
            )}

            {isShowDashboardIcon && (
              <img
                width={25}
                height={25}
                src={columnsIcon}
                className="mr-5 filter-black"
                style={{ cursor: "pointer", marginRight: "20px" }}
                onClick={(): void => this.navbarViewModel.onDashboardClicked()}
              />
            )}

            {isShowUsersIcon && (
              <img
                width={25}
                height={25}
                src={usersIcon}
                className="filter-black"
                style={{ cursor: "pointer", marginRight: "20px" }}
                onClick={(): void => this.navbarViewModel.onUsersClicked()}
              />
            )}

            <OverlayTrigger
              placement="bottom"
              delay={{ show: 100, hide: 100 }}
              overlay={<Tooltip id="logout-tooltip">Members area</Tooltip>}
            >
              <img
                width={27}
                height={27}
                src={userIcon}
                className="filter-black"
                style={{ cursor: "pointer", marginRight: "20px" }}
                onClick={(): void => {
                  window.open('https://commissiondragon.convertri.com/junglejuicemember', "_blank");
                }}
              />
            </OverlayTrigger>

            <OverlayTrigger
              placement="bottom"
              delay={{ show: 100, hide: 100 }}
              overlay={<Tooltip id="logout-tooltip">Logout</Tooltip>}
            >
              <img
                width={20}
                height={20}
                src={exitIcon}
                className="filter-black"
                style={{ cursor: "pointer" }}
                onClick={(): void => this.navbarViewModel.onLogoutClicked()}
              />
            </OverlayTrigger>
          </div>
        </div>
      </div>
    );
  };
}
